/**
 * Auto-load more products on collection PLPs and /search (IntersectionObserver).
 * Collections: fetch only the product-grid section (?section_id=).
 * Search: fetch templates/search.dw-infinite.liquid (?view=dw-infinite).
 * Never parse a full HTML document — that is what Chrome kills
 * (RESULT_CODE_KILLED_BAD_MESSAGE). Hub listing pages must not mount this script.
 */
(function () {
  if (window.__dwCollectionProductsInfiniteInit) return;
  window.__dwCollectionProductsInfiniteInit = true;

  var SEL_WRAP = '.dw-collection-products-infinite';
  var SEL_GRID = '.products-grid.collection-grid[data-dw-products-infinite]';
  var SEL_ITEM = '.dw-collection-product-item';
  var SEL_NEXT = '.dw-collection-products-infinite__next';
  var SEL_STATUS = '.dw-collection-products-infinite__status';
  var SEL_SENTINEL = '.dw-collection-products-infinite__sentinel';
  var SEL_PAGER = '.dw-collection-products-infinite__pager';
  var MAX_FRAGMENT_CHARS = 800000;

  function setStatus(wrap, text) {
    var status = wrap.querySelector(SEL_STATUS);
    if (status) status.textContent = text || '';
  }

  function findGrid(wrap) {
    if (!wrap) return null;
    var parent =
      wrap.closest('.product-grid-isotope-parent') || wrap.closest('.search-page');
    if (parent) {
      var inParent = parent.querySelector(SEL_GRID);
      if (inParent) return inParent;
    }
    return document.querySelector(SEL_GRID);
  }

  function sectionFetchUrl(href, wrap) {
    var url = new URL(href, window.location.origin);
    var view = wrap && wrap.getAttribute('data-dw-infinite-view');
    if (view) {
      url.searchParams.set('view', view);
      url.searchParams.delete('section_id');
    } else {
      var sid = wrap && wrap.getAttribute('data-dw-section-id');
      if (sid) url.searchParams.set('section_id', sid);
    }
    return url.toString();
  }

  function htmlIsUnsafeFragment(html) {
    if (!html) return true;
    if (html.length > MAX_FRAGMENT_CHARS) return true;
    if (/Result code:\s*killed/i.test(html)) return true;
    var head = html.slice(0, 256).toLowerCase();
    return head.indexOf('<!doctype') !== -1 || /<html[\s>]/i.test(head);
  }

  function done(wrap) {
    wrap.setAttribute('data-dw-infinite-done', '1');
    var obs = wrap.__dwInfiniteObs;
    if (obs) {
      obs.disconnect();
      wrap.__dwInfiniteObs = null;
    }
    var next = wrap.querySelector(SEL_NEXT);
    if (next) next.remove();
    var sentinel = wrap.querySelector(SEL_SENTINEL);
    if (sentinel) sentinel.remove();
    var pager = wrap.querySelector(SEL_PAGER);
    if (pager) pager.remove();
    setStatus(wrap, wrap.getAttribute('data-dw-done-label') || '');
  }

  function updateHistory(href) {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(href, window.location.origin);
      var page = url.searchParams.get('page');
      var current = new URL(window.location.href);
      if (page && page !== '1') {
        current.searchParams.set('page', page);
      } else {
        current.searchParams.delete('page');
      }
      current.searchParams.delete('section_id');
      current.searchParams.delete('view');
      window.history.replaceState(
        { dwCollectionInfinite: true, page: page || '1' },
        '',
        current.pathname + current.search + current.hash
      );
    } catch (e) {
      /* ignore */
    }
  }

  function appendItems(grid, remoteGrid) {
    var added = 0;
    if (!grid || !remoteGrid) return added;
    var nodes = Array.prototype.slice.call(remoteGrid.querySelectorAll(SEL_ITEM));
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node || node.nodeType !== 1) continue;
      var scripts = node.querySelectorAll('script');
      for (var s = 0; s < scripts.length; s++) scripts[s].remove();
      grid.appendChild(node);
      added += 1;
    }
    return added;
  }

  function loadNext(wrap) {
    if (!wrap || wrap.getAttribute('data-dw-infinite-loading') === '1') return;
    if (wrap.getAttribute('data-dw-infinite-done') === '1') return;

    var next = wrap.querySelector(SEL_NEXT);
    var href = next && next.getAttribute('href');
    if (!href) {
      done(wrap);
      return;
    }

    wrap.setAttribute('data-dw-infinite-loading', '1');
    setStatus(wrap, wrap.getAttribute('data-dw-loading-label') || 'Loading…');

    fetch(sectionFetchUrl(href, wrap), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (htmlIsUnsafeFragment(html)) throw new Error('unsafe fragment');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var added = appendItems(findGrid(wrap), doc.querySelector(SEL_GRID));
        var remoteWrap = doc.querySelector(SEL_WRAP);
        var remoteNext = remoteWrap && remoteWrap.querySelector(SEL_NEXT);
        var nextHref = remoteNext && remoteNext.getAttribute('href');

        if (nextHref && next && added > 0) {
          next.setAttribute('href', nextHref);
          var pagerLink = wrap.querySelector(SEL_PAGER + ' a[rel="next"]');
          if (pagerLink) pagerLink.setAttribute('href', nextHref);
          updateHistory(href);
          wrap.removeAttribute('data-dw-infinite-loading');
          setStatus(wrap, '');
        } else {
          updateHistory(href);
          done(wrap);
        }
      })
      .catch(function () {
        wrap.removeAttribute('data-dw-infinite-loading');
        setStatus(wrap, wrap.getAttribute('data-dw-error-label') || 'Could not load more. Try again.');
        if (next) next.hidden = false;
      });
  }

  function bindWrap(wrap) {
    if (!wrap || wrap.getAttribute('data-dw-infinite-bound') === '1') return;
    wrap.setAttribute('data-dw-infinite-bound', '1');

    var next = wrap.querySelector(SEL_NEXT);
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        next.hidden = true;
        loadNext(wrap);
      });
    }

    var sentinel = wrap.querySelector(SEL_SENTINEL);
    if (sentinel && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext(wrap);
          });
        },
        { rootMargin: '240px 0px' }
      );
      wrap.__dwInfiniteObs = obs;
      obs.observe(sentinel);
    } else if (next) {
      next.hidden = false;
    }
  }

  function init() {
    document.querySelectorAll(SEL_WRAP).forEach(bindWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
